/**
 * Where the file of a record physically lives.
 *
 * Files created before the migration to MinIO stay in the external providers and are not copied
 * over, so the provider has to be recorded per row: it is what tells a legacy file apart from one
 * that is simply missing.
 */
export enum StorageProviderType {
  MINIO = "MINIO",
  BACKBLAZE = "BACKBLAZE",
  AWS_S3 = "AWS_S3"
}
